import $ from "jquery";

/**
 * Send an individual Google Analytics event.
 * Works with gtag('event') and ga('send').

 * @param {string} category
 * @param {string} action
 * @param {string} label

 * About nonInteraction: true
 * https://support.google.com/analytics/answer/1033068#NonInteractionEvents
 * TLDR; Enables accurate, non-deflated bounce rates.

 * About transport: beacon
 * https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#transport
 * TLDR; Allows tracking link clicks even if the page reloads before the request finishes.
 */

function sendEvent(category, action, label) {
  var label = $.trim(label);

  /* DEBUG */
  console.info("Custom Event Sent", {
    type: 'click',
    action: action,
    category: category,
    label: label,
    url: window.location.pathname
  });

  let event_data = {
    type: 'click',
    action: action,
    category: category,
    label: label,
    url: window.location.pathname
  };

  if (typeof gtag !== "undefined") {
    gtag("event", action, {
      event_category: category,
      event_label: label,
      non_interaction: true,
    });
  } else if (typeof ga !== "undefined") {
    ga("send", {
      hitType: "event",
      eventCategory: category,
      eventAction: action,
      eventLabel: label,
      nonInteraction: true,
      transport: "beacon",
    });
  }

  if (window.umami && umami.track) {
    umami.track(label, event_data);
  }
}

/**
 * Returns data set by a parent element
 */

function inheritAttribute($el, attribute) {
  return $el
    .parents("[data-ga-" + attribute + "]")
    .first()
    .attr("data-ga-" + attribute);
}

/**
 * Sets the right GA variables for sendEvent().
 * Sets defaults where values are missing or cannot be set manually.

 * @param {jQuery selector} $t - The jQuery selector to be tracked.
 * @param {object} data - allows overriding values for specific cases.

 * Order of attributes importance:
 * - data sent by an event
 * - data set on the element
 * - if neither is set, attributes from parents will be used.

 * Default link label is the link URL.

 * Utilities:
 * data-ga-label=':text' - Sets the default label to the element display *text*, instead of its URL.
 * data-ga-label=':tracklocation' - Sets the default label to the current window.location.href.
 * It can be set on a container element and all links will inherit the rule, unless a label is explicitly set.
 * Example usage is available on the components/footer.php, components/pagination.php and header.php modules.
 */

function gaTrack($t, data) {
  var category =
    (data && data.category) ||
    $t.attr("data-ga-category") ||
    inheritAttribute($t, "category");
  var action =
    (data && data.action) ||
    $t.attr("data-ga-action") ||
    inheritAttribute($t, "action") ||
    "Link";
  var label = $t.attr("href"); // default label

  // If a label is set via event data
  if (data && data.label) {
    label = data.label;
  }
  // If the element's label is set in an attribute
  else if ($t.attr("data-ga-label")) {
    if ($t.attr("data-ga-label") == ":text") {
      label = $t.text();
    } else if ($t.attr("data-ga-label") == ":tracklocation") {
      label = window.location.href;
    } else {
      label = $t.attr("data-ga-label");
    }
  }
  // If a label is set by a parent
  else if ($t.parents("[data-ga-label]").length) {
    if (inheritAttribute($t, "label") == ":text") {
      label = $t.text();
    } else {
      label = inheritAttribute($t, "label");
    }
  }

  if ($t.attr("data-ga-tracklocation")) {
    label += " " + window.location.href;
  }

  sendEvent(category, action, label);
}

// Bellow are all the GA tracking events.

/**
 * Individual element tracking.

 * Example markup:
 * class="js-ga-track" data-ga-category="Jobs" data-ga-action="Link" data-ga-label="Senior Digital Designer"

 * Leaving out the data-ga-action attribute will default it to 'Link'
 * Leaving out the data-ga-label attribute will default it to the href attribute (URL)
 */

$("body").on("click", ".js-ga-track", function () {
  gaTrack($(this));
});

/**
 * Track all links inside a container.
 * Default label: href attribute

 * Example markup:
 * class="js-ga-track-links" data-ga-category="Footer"

 * Leaving out the data-ga-action attribute will default all links to 'Link'
 * Leaving out the data-ga-label attribute will default all links to their href attribute (URL)
 */

$("body").on("click", ".js-ga-track-links a", function () {
  gaTrack($(this));
});

/**
 * Track by emitting an event.
 * Events need to send all 3 attributes.
 */

$(window).on("ga.event", function (e, data) {
  sendEvent(data.category, data.action, data.label);
});

/**
 * Track .pdf .doc .docx links (docx implicit from containing .doc)
 * Use * for 'contain' rather than 'ends in' to accound for links with params
 */

$("body").on("click", '[href*=".pdf"], [href*=".doc"]', function () {
  sendEvent("Documents", "Click", $(this).attr("href"));
});

/**
 * Track main menu clicks
 * Includes: desktop main menu, hamburger main menu, mobile branch menu
 */

$("body").on(
  "click",
  ".menu-header-nav__menu a, .menu-header-top__menu a",
  function () {
    sendEvent("Menu items", "Click", $(this).text());
  }
);

/**
 * Search queries
 */

$(".searchform").on("submit", function () {
  sendEvent("Search", "Search", $(this).find('input[name="s"]').val());
});
